export default __webpack_public_path__ + "static/media/rare-animals.a743a77a.svg";